<template>
  <div>
    <el-form :model="form" status-icon ref="ruleForm" label-width="140px" size="small" style="position: relative">
      <!-- 1：输入框；2：性别；3：身份证； 4：时间选择器；5：省市区三级联动；6：手机号；7： ；8：政治面貌；9：婚姻状况；10：最高学历；11：最高学位；12：考生照片；13：学历类别；14：； -->
      <div v-for="(item, index) in form.wordInfo" :key="index">
        <!-- 普通输入框-->
        <el-form-item v-if="item.fieldType == 1 || item.fieldType == 101 || !item.fieldType" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'blur',
            },
          ]">
          <el-input :disabled="item.disabled" type="text" :placeholder="handlePlcaeHolder(item)" v-model="item.applyValue"
            autocomplete="off"></el-input>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 性别-->
        <el-form-item v-if="item.fieldType == 2 || item.fieldType == 102" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: '请选择性别',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <!-- 身份证 -->
        <el-form-item v-if="item.fieldType == 3 || item.fieldType == 103" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="idCodeRules">
          <el-input :placeholder="handlePlcaeHolder(item)" v-model="item.applyValue" :disabled="item.disabled"></el-input>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 时间选择器 -->
        <el-form-item v-if="item.fieldType == 4 || item.fieldType == 104" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-date-picker :disabled="item.disabled" v-model="item.applyValue" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" type="date" :placeholder="handlePlcaeHolder(item)" style="width: 100%">
          </el-date-picker>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 省市区三级联动 -->
        <el-form-item v-if="item.fieldType == 5 || item.fieldType == 105" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="areaRules">
          <el-cascader :disabled="item.disabled" :placeholder="handlePlcaeHolder(item)" clearable
            :options="$store.state.areaList" v-model="item.applyValue" style="width: 100%"></el-cascader>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 手机号 -->
        <el-form-item v-if="item.fieldType == 6 || item.fieldType == 106" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="phoneNumRules">
          <el-input :placeholder="handlePlcaeHolder(item)" v-model="item.applyValue" :disabled="item.disabled"></el-input>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 政治面貌下拉框 -->
        <el-form-item v-if="item.fieldType == 8 || item.fieldType == 108" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="item in $store.state.politicList" :key="item.typeCode" :label="item.typeName"
              :value="item.typeCode">
            </el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 婚姻状况下拉框 -->
        <el-form-item v-if="item.fieldType == 9 || item.fieldType == 109" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="item in $store.state.marryList" :key="item.typeCode" :label="item.typeName"
              :value="item.typeCode">
            </el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 最高学历下拉框 -->
        <el-form-item v-if="item.fieldType == 10 || item.fieldType == 1010" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="item in $store.state.educationList" :key="item.typeCode" :label="item.typeName"
              :value="item.typeCode">
            </el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 最高学位下拉框 -->
        <el-form-item v-if="item.fieldType == 11 || item.fieldType == 1011" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="item in $store.state.degreeList" :key="item.typeCode" :label="item.typeName"
              :value="item.typeCode">
            </el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 考生照片 -->
        <el-form-item label-width="0" :prop="'wordInfo.' + index + '.applyValue'" :rules="[
          {
            required: item.isRequired == '1' ? true : false,
            message: '请上传考生照片',
            trigger: ['change', 'blur'],
          },
        ]" class="imgBox" v-if="item.fieldType == 12 || item.fieldType == 1012">
          <img v-if="form.wordInfo[index].applyValue" :src="'/file/fileInfo/getFile?id=' + form.wordInfo[index].applyValue
            " alt="" />
          <p v-else>请上传JPG、PNG格式的本人免冠照片</p>
          <div class="imgBox-shadow">
            <el-upload class="upload-demo" action="/file/fileInfo/fileUpload?fileType=0" :show-file-list="false"
              list-type="picture" :on-success="handleUploadSuccess">
              <i class="el-icon-plus"></i>
              <i class="el-icon-delete" @click.stop="removePhoto" style="color: red; margin-left: 10px"></i>
            </el-upload>
          </div>
        </el-form-item>
        <!-- 特定下拉框-->
        <el-form-item v-if="item.fieldType == 99 || item.fieldType == 1099" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: '请选择' + item.applyName,
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="(option, key) in item.selectOptions" :key="key" :label="option.label"
              :value="option.label"></el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 学历类别下拉框 -->
        <el-form-item v-if="item.fieldType == 13 || item.fieldType == 1013" :label="item.applyName"
          :prop="'wordInfo.' + index + '.applyValue'" :rules="[
            {
              required: item.isRequired == '1' ? true : false,
              message: item.applyName + '不可为空',
              trigger: 'change',
            },
          ]">
          <el-select :disabled="item.disabled" v-model="item.applyValue" :placeholder="handlePlcaeHolder(item)"
            style="width: 100%">
            <el-option v-for="item in $store.state.educationType" :key="item.typeCode" :label="item.typeName"
              :value="item.typeCode">
            </el-option>
          </el-select>
          <p class="attentionWWord">{{ item.fielddetailMemo }}</p>
        </el-form-item>
        <!-- 家庭成员 -->
        <div class="applyInfoTable" v-if="item.fieldType == 98 || item.fieldType == 1098">
          <el-form-item label="家庭成员" :required="item.isRequired == '1'" size="mini">
            <el-table v-if="loading" :data="item.applyValue" border style="width: 100%"
              :header-cell-style="{ background: '#e6e9ed', color: '#333' }">
              <el-table-column fixed prop="relation" label="称谓" width="100">
              </el-table-column>
              <el-table-column prop="name" label="姓名" width="100">
              </el-table-column>
              <el-table-column prop="policy" label="政治面貌" width="120">
              </el-table-column>
              <el-table-column prop="work" label="工作单位及职位">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="130">
                <template slot-scope="scope">
                  <div class="cellBtnBox">
                    <span @click="editMember(scope.$index, scope.row)">
                      修改
                    </span>
                    <span @click="handleMemberDelete(scope.$index, item.applyValue)">
                      删除
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <p class="tableAddBtn">
              <span @click="addMember">点此新增家庭主要成员</span>
            </p>
          </el-form-item>
        </div>
        <!-- 工作经历或教育经历 -->
        <div class="applyInfoTable" v-if="item.fieldType == 97 || item.fieldType == 1098">
          <el-form-item label="工作经历或教育经历" :required="item.isRequired == '1'" size="mini">
            <el-table v-if="loading" :data="item.applyValue" border style="width: 100%"
              :header-cell-style="{ background: '#e6e9ed', color: '#333' }">
              <el-table-column prop="entryDate" label="开始年月" width="100">
              </el-table-column>
              <el-table-column prop="leaveDate" label="结束年月" width="100">
              </el-table-column>
              <el-table-column prop="company" label="所在单位或学校">
              </el-table-column>
              <el-table-column prop="postName" label="职务或专业" width="120">
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="130">
                <template slot-scope="scope">
                  <div class="cellBtnBox">
                    <span @click="editWork(scope.$index, scope.row)">
                      修改
                    </span>
                    <span @click="handleWorkDelete(scope.$index, item.applyValue)">
                      删除
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <p class="tableAddBtn">
              <span @click="addWork">点此新增工作经历或教育经历</span>
            </p>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <!-- 新增家庭成员 -->
    <el-dialog title="家庭成员" :visible.sync="dialogMemberFormVisible" width="500px">
      <el-form :model="memberInfo" ref="memberInfoRef" :rules="memberRules" size="small" label-position="top"
        label-width="120px">
        <el-form-item label="称谓" prop="relation" required>
          <el-input v-model="memberInfo.relation" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name" required>
          <el-input v-model="memberInfo.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="政治面貌" prop="policy" required>
          <el-input v-model="memberInfo.policy" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="工作单位及职位" prop="work" required>
          <el-input v-model="memberInfo.work" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogMemberFormVisible = false" size="small">
          取 消
        </el-button>
        <el-button type="primary" v-if="dialogMemberType == 'add'" @click="handleMemberAdd" size="small">
          确 定
        </el-button>
        <el-button type="primary" v-if="dialogMemberType == 'edit'" @click="handleMemberEdit" size="small">
          修改
        </el-button>
      </div>
    </el-dialog>
    <!-- 新增工作经历或教育经历 -->
    <el-dialog title="学习及工作简历（从高中填起）" :visible.sync="dialogWorkFormVisible" width="500px">
      <el-form :model="workInfo" ref="workInfoRef" :rules="workRules" size="small" label-position="top"
        label-width="120px">
        <el-form-item label="开始年月" prop="entryDate">
          <el-date-picker v-model="workInfo.entryDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择开始年月" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束年月" prop="leaveDate">
          <el-date-picker v-model="workInfo.leaveDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
            placeholder="请选择开始年月" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所在单位或学校" prop="company">
          <el-input v-model="workInfo.company" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职务或专业" prop="postName">
          <el-input v-model="workInfo.postName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogWorkFormVisible = false" size="small">
          取 消
        </el-button>
        <el-button type="primary" v-if="dialogWorkType == 'add'" @click="handleWorkAdd" size="small">
          确 定
        </el-button>
        <el-button type="primary" v-if="dialogWorkType == 'edit'" @click="handleWorkEdit" size="small">
          修改
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FormList",
  props: {
    form: Object,
  },
  data() {
    let _that = this;
    return {
      // 身份证号校验
      idCodeRules: [
        {
          required: true,
          message: "身份证号不可为空",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) =>
            _that.$commonFunc.validateIdCode(rule, value, callback),
          trigger: "blur",
        },
      ],
      // 手机号校验
      phoneNumRules: [
        {
          required: true,
          message: "手机号不可为空",
          trigger: "blur",
        },
        {
          validator: (rule, value, callback) =>
            _that.$commonFunc.validatePhoneNum(rule, value, callback),
          trigger: "blur",
        },
      ],
      // 级联面板校验
      areaRules: [
        {
          required: true,
          message: "该值不可为空",
          trigger: "change",
        },
        {
          validator: (rule, value, callback) =>
            _that.$commonFunc.validCascader(rule, value, callback),
          trigger: "change",
        },
      ],
      // 新增家庭成员对话框
      dialogMemberFormVisible: false,
      // 家庭成员对话框类型
      dialogMemberType: "",
      memberRules: {
        relation: [
          {
            required: true,
            message: "请填写称谓",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请填写成员姓名",
            trigger: "blur",
          },
        ],
        policy: [
          {
            required: true,
            message: "请填写成员政治面貌",
            trigger: "blur",
          },
        ],
        work: [
          {
            required: true,
            message: "请填写成员工作单位及职位",
            trigger: "blur",
          },
        ],
      },
      // 家庭成员
      memberInfo: {
        relation: "",
        name: "",
        policy: "",
        work: "",
      },
      // 操作数据的索引
      memberIndex: -1,
      // 新增工作经历或教育经历对话框
      dialogWorkFormVisible: false,
      // 工作经历或教育经历对话框类型
      dialogWorkType: "",
      workRules: {
        company: [
          {
            required: true,
            message: "请填写公司名称",
            trigger: "blur",
          },
        ],
        postName: [
          {
            required: true,
            message: "请填写所任职位",
            trigger: "blur",
          },
        ],
        entryDate: [
          {
            required: true,
            message: "请填写任职日期",
            trigger: "blur",
          },
        ],
        leaveDate: [
          {
            required: true,
            message: "请填写离职日期",
            trigger: "blur",
          },
        ],
      },
      // 工作经历或教育经历
      workInfo: {
        company: "",
        postName: "",
        entryDate: "",
        leaveDate: "",
      },
      // 操作数据的索引
      workIndex: -1,
      // 动态刷新表格 标志
      loading: true,
    };
  },
  methods: {
    // 处理提示词
    handlePlcaeHolder(item) {
      if (item.fielddetailMemo) {
        return item.fielddetailMemo;
      } else {
        return "请填写" + item.applyName;
      }
    },
    // 上传成功回调
    handleUploadSuccess(response, file, fileList) {
      // 获取fileType == 12 的索引
      let index = this.form.wordInfo.findIndex((item) => {
        return item.fieldType == 12 || item.fieldType == 1012;
      });
      if (index !== -1) {
        if (response.success) {
          this.form.wordInfo[index].applyValue = response.obj;
        } else {
          this.$message.error(response.msg);
        }
      }
    },
    // 家庭成员校验
    handleFamilyValidate(name, parent) {
      let params = "该项";
      if (parent.isRequired == "1") {
        name ? (params = name) : "";
        return {
          required: true,
          message: params + "不可为空",
          trigger: "blur",
        };
      } else {
        return [];
      }
    },
    // 表单校验
    formValidate() {
      let _that = this;
      let flag = false;
      _that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else flag = false;
      });
      return flag;
    },
    // 表单重置
    resetFormData() {
      this.$refs["ruleForm"].resetFields();
    },
    // 移除照片
    removePhoto() {
      // 获取fileType == 12 的索引
      let index = this.form.wordInfo.findIndex((item) => {
        return item.fieldType == 12 || item.fieldType == 1012;
      });
      if (index !== -1) {
        this.form.wordInfo[index].applyValue = "";
      }
    },
    // 显示新增家庭成员对话框
    addMember() {
      this.dialogMemberType = "add";
      this.dialogMemberFormVisible = true;
    },
    // 新增家庭成员
    handleMemberAdd() {
      let _that = this;
      let obj = JSON.parse(JSON.stringify(_that.memberInfo));
      this.$refs["memberInfoRef"].validate((valid) => {
        if (valid) {
          let params = _that.form.wordInfo.findIndex((item) => {
            return item.fieldType == "98";
          });
          if (params !== -1) {
            _that.form.wordInfo[params].applyValue.push(obj);
            _that.memberInfo = {
              relation: "",
              name: "",
              policy: "",
              work: "",
            };
            _that.dialogMemberFormVisible = false;
          }
        }
      });
    },
    // 显示修改家庭成员对话框
    editMember(index, row) {
      this.memberInfo = JSON.parse(JSON.stringify(row));
      this.memberIndex = index;
      this.dialogMemberType = "edit";
      this.dialogMemberFormVisible = true;
    },
    // 修改家庭成员
    handleMemberEdit() {
      let _that = this;
      let obj = JSON.parse(JSON.stringify(_that.memberInfo));
      this.$refs["memberInfoRef"].validate((valid) => {
        if (valid) {
          let params = _that.form.wordInfo.findIndex((item) => {
            return item.fieldType == "98";
          });
          if (params !== -1) {
            _that.form.wordInfo[params].applyValue[_that.memberIndex] = obj;
            _that.loading = false;
            _that.$nextTick(() => {
              _that.loading = true;
              _that.dialogMemberFormVisible = false;
            });
          }
        }
      });
    },
    // 移除家庭成员
    handleMemberDelete(index, rows) {
      rows.splice(index, 1);
    },
    // 显示新增工作经历或教育经历对话框
    addWork() {
      this.dialogWorkType = "add";
      this.dialogWorkFormVisible = true;
    },
    // 显示修改工作经历或教育经历对话框
    editWork(index, row) {
      this.workInfo = JSON.parse(JSON.stringify(row));
      this.workIndex = index;
      this.dialogWorkType = "edit";
      this.dialogWorkFormVisible = true;
    },
    // 新增工作经历或教育经历
    handleWorkAdd() {
      let _that = this;
      let obj = JSON.parse(JSON.stringify(_that.workInfo));
      this.$refs["workInfoRef"].validate((valid) => {
        if (valid) {
          let params = _that.form.wordInfo.findIndex((item) => {
            return item.fieldType == "97";
          });
          if (params !== -1) {
            _that.form.wordInfo[params].applyValue.push(obj);
            _that.workInfo = {
              company: "",
              postName: "",
              entryDate: "",
              leaveDate: "",
            };
            _that.dialogWorkFormVisible = false;
          }
        }
      });
    },
    // 修改工作经历或教育经历
    handleWorkEdit() {
      let _that = this;
      let obj = JSON.parse(JSON.stringify(_that.workInfo));
      this.$refs["workInfoRef"].validate((valid) => {
        if (valid) {
          let params = _that.form.wordInfo.findIndex((item) => {
            return item.fieldType == "97";
          });
          if (params !== -1) {
            _that.form.wordInfo[params].applyValue[_that.workIndex] = obj;
            _that.loading = false;
            _that.$nextTick(() => {
              _that.loading = true;
              _that.dialogWorkFormVisible = false;
            });
          }
        }
      });
    },
    // 移除家庭成员
    handleWorkDelete(index, rows) {
      rows.splice(index, 1);
    },
  },
  watch: {
    dialogMemberFormVisible(newVal, oldVal) {
      if (!newVal) {
        this.$refs["memberInfoRef"].resetFields();
      }
    },
  },
};
</script>

<style scoped>
.imgBox {
  width: 140px;
  height: 185px;
  text-align: right;
  position: absolute;
  left: 0;
  top: 0;
  transform: translateX(-100%);
  border: 1px dashed #ccc;
  cursor: pointer;
}

.imgBox img {
  width: 100%;
  height: 100%;
}

.imgBox p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  font-size: 12px;
  text-align: center;
  color: #e4e4e4;
}

.imgBox:hover .imgBox-shadow {
  display: block;
}

.imgBox-shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(221, 221, 221, 0.2);
  display: none;
}

.upload-demo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 24px;
  color: #409eff;
}

.imgBox-fomeItem .el-form-item__content {
  height: 100%;
}

.attentionWWord {
  position: absolute;
  top: 0;
  left: calc(100% + 10px);
  width: 400px;
  color: red;
}

.tableAddBtn {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 13px;
}

.tableAddBtn span {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/common/FormList/FormList.vue